import GearIcon from './gear-icon';

export default GearIcon;
